import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { ACTION_TYPES, FORM_TYPES } from "../context/cadastros-basico-reducer";
import { useCadastrosBasicoDispatch, useCadastrosBasicoState } from "../context/cadastros-basico-context";
import { BannerForm } from "./banners-form";
import { LinkServicosForm } from "./link-servicos-form";
import { NoticiasForm } from "./noticas-form";
import { CategoriaNoticiasForm } from "./categoria-noticias-form";
import { useCadastrosBasicoController } from "../context/cadastros-basico-controller";
import { EstruturaGovernamentalForm } from "./estrutura-governamental-form";
export const CadastroBasicoDrawer = ({ formType }: { formType: FORM_TYPES }) => {
    const { showDialog } = useBaseLayoutController();
    const { save,setInitialValues } = useCadastrosBasicoController();
    const { dataResponse, showAddEdit } = useCadastrosBasicoState();
    const cadastrosBasicoDispatch = useCadastrosBasicoDispatch();

    useEffect(() => {
      setInitialValues()  ;
    }, [showAddEdit]);

    const onClose = () => {
        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setShowAddEdit,
            payload: false,
        });
        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setDataResponse,
            payload: null,
        });
    }

    const renderForm = (formType: FORM_TYPES): any => {
        switch (formType) {
            case FORM_TYPES.banners:
                return <BannerForm></BannerForm>
            case FORM_TYPES.categoriesNews:
                return <CategoriaNoticiasForm></CategoriaNoticiasForm>
            case FORM_TYPES.linkServices:
                return <LinkServicosForm></LinkServicosForm>
            case FORM_TYPES.news:
                return <NoticiasForm></NoticiasForm>
            case FORM_TYPES.estruturaGovernametal:
                return <EstruturaGovernamentalForm></EstruturaGovernamentalForm>
        }
    }

    const actions = () => {
        return (
            <React.Fragment>
                <Button variant="contained" onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save(formType);
                            })();
                        }
                    } as DefaultDialogProps);
                }} endIcon={<SaveIcon />}>Salvar</Button>




            </React.Fragment >
        )
    }

    const getTitle = (formType: FORM_TYPES): string => {

        let formName = "";
        switch (formType) {
            case FORM_TYPES.banners:
                formName = "Banner";
                break;
            case FORM_TYPES.linkServices:
                formName = "Link de Serviços";
                break;
            case FORM_TYPES.categoriesNews:
                formName = "Categoria de Notícias";
                break;
            case FORM_TYPES.news:
                formName = "Notícias";
                break;
                case FORM_TYPES.estruturaGovernametal:
                    formName = "Estrutura Governamental";
                    break;
            default:
                formName = "";
                break;


        }

        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar ${formName} ${dataResponse?.id}`;
        else
            return `Adicionar ${formName}`;
    }


    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle(formType)} onClose={onClose}
            actions={() => {
                return actions();
            }}>
            <React.Fragment>
                {renderForm(formType)}
            </React.Fragment>
        </DefaultDrawer>
    )
}